export default __webpack_public_path__ + "static/media/1.b888ea66.jpg";